require('../../style/base.css');
require('../index.css');


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/lib/pull-refresh/style/index.js
// module id = ZV4y
// module chunks = 0